<template>
  <div class="user-warp">
    <div class="user-warp-bg" @click="onClose"></div>
    <div class="user-warp-content">
      <img src="https://resource.rcclchina.com.cn/tui2/info/sanjiao.png" alt="" class="triangle">
      <div class="user-title">常用乘客({{contacts.length}})</div>
      <div v-if="isDesc" class="user-desc">同一航次，同一乘客不可重复添加</div>
      <div class="user-list">
        <div class="user-item" v-for="contact in contacts" :key="('contact_'+contact.id)"
             :class="{ active: isSelected(contact)}" @click="onContactClicked(contact)">
          <div class="user-name">{{getContactName(contact)}}</div>
          <div class="user-other-info">
            <span v-show="getContactGender(contact)">{{getContactGender(contact)}}</span>
            <span v-show="getContactGender(contact) && contact.dateOfBirth">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
            <span v-show="contact.dateOfBirth" class="birthday">{{contact.dateOfBirth}}</span>
          </div>
        </div>
      </div>
      <div class="user-footer">
        <div>
          <div class="user-clear-btn" @click="onClose">取消</div>
          <div class="user-confirm-btn" @click="confirmContact">确认</div>
        </div>
      </div>
      <div class="warning-tip" v-show="isShowLimit">
        <span>该舱房最多可{{isFill ? '补填' : '选'}}{{bookingLimit}}名乘客</span>
        <img src="https://resource.rcclchina.com.cn/tui2/info/close.png" @click="isShowLimit=false">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectContact",
  props: {
    isFill: {
      type: Boolean,
      default: false
    },
    isDesc: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default () {
        return 0
      }
    },
    selectContactIds: {
      type: Array,
      default () {
        return []
      }
    },
    onContactConfirm: {
      type: Function
    },
    onClose: {
      type: Function
    },
    bookingLimit: {
      type: Number,
      default () {
        return 4
      }
    },
    isContact:{
      type: Boolean,
      default: false
    }
  },
  beforeMount () {
    this.selectContact = this.contacts.filter(r=> this.selectContactIds.indexOf(r.id) >= 0)
  },
  data () {
    return {
      selectContact: [],
      isShowLimit: false
    }
  },
  methods: {
    getContactName (contact) {
      let title = (contact.chineseLastName || '')+(contact.chineseFirstName || '')
      if (title == '') {
        title = `${contact.pinyinLastName} ${contact.pinyinFirstName}`
      }
      return title
    },
    getContactGender (contact) {
      if (contact.gender == 'M') return '男'
      else if (contact.gender == 'F') return '女'
      return contact.gender
    },
    onContactClicked (contact) {
      if (this.isSelected(contact)) {
        this.selectContact = this.selectContact.filter(r=>r.id != contact.id)
      } else {
        if (this.selectContact.length == this.bookingLimit) {
          this.isShowLimit = true
          setTimeout(()=> {
            this.isShowLimit = false
          }, 4000)
          return
        } else if (this.selectContact.length == this.limit) {
          return
        } else {
          this.selectContact.push(contact)
        }
      }
    },
    isSelected (contact) {
      return this.selectContact.some(r=>r.id == contact.id)
    },
    confirmContact () {
      const guests = this.getGuestsByContacts(this.selectContact)
      if (guests.length == 0) return
      this.onContactConfirm(guests)
      this.onClose()
    },
    // 将常用联系人转换成乘客对象
    getGuestsByContacts (contacts) {
      let guests = []
      contacts.forEach((contact) => {
        let name = contact.chineseLastName + contact.chineseFirstName
        if (!name || name.trim().length == 0) {
          name = `${contact.pinyinLastName} ${contact.pinyinFirstName}`
        }
        let guest = {
          nationality: contact.country || "CN",
          lastName: contact.chineseLastName,
          firstName: contact.chineseFirstName,
          pyLastName: contact.pinyinLastName,
          pyFirstName: contact.pinyinFirstName,
          name: name,
          birthDate: contact.dateOfBirth,
          passport: contact.passportNum,
          passportExpiresIn: contact.passportExpirationDate,
          gender: contact.gender || "M",
          telephone: contact.telephone,
          email: contact.email,
          callingCode: contact.callingCode || "86",
          id: contact.id
        }

        // 检查country code
        const checkReg = new RegExp("[A-Za-z]+")
        if (!checkReg.test(guest.nationality)) {
          let country = this.countries.filter(r=>r.countryName == guest.nationality)
          if (country) {
            guest.nationality = country.countryCode
          }
        }
        guests.push(guest)
      })
      return guests
    }
  },
  computed: {
    contacts () {
      let contacts = []
      if(this.isContact){
        contacts = this.$store.state.user.contacts.filter(item => item.email && item.telephone)
        return contacts || []
      }
      return this.$store.state.user.contacts || []
    },
    countries () {
      return this.$store.state.page.countries || []
    }
  }
}
</script>

<style lang="less" scoped>
.user-warp {
  position: absolute;
  top: 34px;
  left: 60px;
  margin-top: 10px;
  color: #747d80;
  width: 584px;
  max-height: 260px;
  background-color: #ffffff;
  box-shadow: 0px 0px 16px 0px rgba(46, 65, 80, 0.17);
  border: solid 1px #d3dadd;
  z-index: 5;
  .user-warp-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: transparent;
    z-index: 1;
  }
  .user-warp-content {
    position: relative;
    z-index: 2;
  }
  .triangle {
    position: absolute;
    top: -25px;
    left: 20px;
    width: 15px;
  }
  .user-title {
    padding-left: 10px;
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .user-desc {
    position: absolute;
    top: 2px;
    right: 10px;
    font-size: 12px;
    color: #999999;
  }
  .user-list {
    background: #fff;
    padding-left: 10px;
    max-height: 200px;
    overflow: scroll;
    overflow-x: hidden;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .user-item {
      position: relative;
      padding: 5px 10px;
      width: 130px;
      height: 66px;
      margin-right: 5px;
      margin-bottom: 10px;
      background-color: #ffffff;
      border: solid 1px #d3dadd;
      display: inline-block;
      cursor: pointer;
      .user-name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .user-other-info {
        font-size: 12px;
        color: #a6aeb1;
      }
    }
    .user-item.active {
      background-image: linear-gradient( #e7f5ff, #e7f5ff), linear-gradient( #ffffff, #ffffff);
      background-blend-mode: normal, normal;
      border: solid 1px #006ab9;
      color: #006ab9;
      .user-other-info {
        color: #006ab9;
        >span {
          color: inherit;
        }
      }
    }
  }
  .user-footer {
    background: #f5f5f5;
    > div {
      width: 178px;
      margin: 0 auto;
      .user-clear-btn {
        margin-right: 10px;
        letter-spacing: 1px;
        cursor: pointer;
      }

      > div {
        line-height: 30px;
        text-align: center;
        display: inline-block;
        width: 78px;
        height: 30px;
        background-color: #ffffff;
        border: solid 1px #d3dadd;
        margin: 10px 6px 10px 0;
      }
      .user-confirm-btn {
        background-color: #006ab9;
        letter-spacing: 1px;
        color: #ffffff;
        cursor: pointer;
      }
    }
  }

  .warning-tip {
    position: absolute;
    /* bottom: -44px; */
    left: 0;
    width: 100%;
    height: 33px;
    background-color: #006ab9;
    opacity: 0.8;
    line-height: 33px;
    text-align: center;
    color: #fff;
    z-index: 5;
    img {
      width: 15px;
      position: absolute;
      top: 10px;
      right: 8px;
    }
  }
}
</style>
